import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EmojiConfigService } from '@sb-tools/typescript/services/emoji-config.service';
import { AvailableBSPositions } from 'ngx-bootstrap/positioning';
import { InlineSVGComponent } from '../../../../sb-modules/Frontend-Inline-SVG-Module/inline-svg.component';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PickerModule } from '@ctrl/ngx-emoji-mart';

@Component({
    selector: 'sb-quill-emoji-picker',
    templateUrl: './quill-emoji-picker.component.html',
    styleUrls: ['./quill-emoji-picker.component.scss'],
    imports: [InlineSVGComponent, PopoverModule, TranslateModule, TooltipModule, PickerModule],
})
export class QuillEmojiPickerComponent {
    @Input() buttonId?: string = '';
    @Input() containerClass?: string = 'smiley-popover';
    @Input() placement?: AvailableBSPositions = 'auto';

    @Output() emojiSelect: EventEmitter<{ $event: PointerEvent; emoji: object }> = new EventEmitter();
    @Output() updateQuillSelection: EventEmitter<void> = new EventEmitter();

    constructor(public emojiConfigService: EmojiConfigService) {}

    searchFocus(): void {
        setTimeout(() => {
            const searchElement = document.getElementsByTagName('emoji-search')[0];
            searchElement.getElementsByTagName('input')[0].focus();
        }, 0);
    }
}
